<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  mixins: [
    countlyVue.mixins.commonFormatters,
  ],
  props: {
    label: { type: String, default: '' },
    number: { type: Number, default: 0 },
    value: { type: String, default: '' },
    description: { type: String, default: '' },
    formatting: { type: String, default: 'auto' },
    isPercentage: { type: Boolean, default: false },
    columnWidth: { type: [Number, String], default: -1 },
    isVertical: { type: Boolean, default: false },
    color: { type: [String, Function, Array], default: '' },
    numberClasses: { type: String, default: 'bu-is-flex bu-is-align-items-baseline' },
    boxType: { type: Number, default: -1 },
    tooltip: { type: String, default: '' },
    exposeMouseEvents: { type: Boolean, default: false },
  },
  computed: {
    formattedNumber() {
      if (this.isNumberSlotUsed) {
        // Avoid extra processing, it won't be shown anyway.
        return '';
      }

      if (this.formatting === 'auto') {
        if (this.isPercentage) {
          return `${this.number} %`;
        }
        if (Math.abs(this.number) >= 10000) {
          return this.getShortNumber(this.number);
        }

        return this.formatNumber(this.number);
      }
      if (this.formatting === 'short') {
        return this.getShortNumber(this.number);
      }
      if (this.formatting === 'long') {
        return this.formatNumber(this.number);
      }

      return this.number;
    },
    isDescriptionSlotUsed() {
      return !!this.$slots.description;
    },
    isNumberSlotUsed() {
      return !!this.$slots.number;
    },
    topClasses() {
      if (this.isVertical || this.columnWidth === -1) {
        return '';
      }

      return `bu-is-${this.columnWidth}`;
    },
    metricStyles() {
      let classes = '';
      if (this.boxType === 3) {
        classes = 'min-width: 33%';
      } else if (this.boxType === 4) {
        classes = 'min-width: 25%';
      } else if (this.boxType === 5) {
        classes = 'min-width: 20%';
      }
      return classes;
    },
  },
});
</script>
<template>
  <div
    class="cly-vue-metric-card bu-column bu-is-flex relative"
    :class="topClasses"
    :style="metricStyles"
  >
    <div class="cly-vue-metric-card__wrapper bu-p-5 bu-is-flex bu-is-justify-content-space-between has-ellipsis">
      <cly-progress-donut
        v-if="isPercentage"
        class="bu-pr-4 bu-is-flex"
        :color="color"
        :percentage="number"
      />
      <div class="bu-is-flex bu-is-flex-direction-column bu-is-justify-content-space-between has-ellipsis">
        <div class="flex items-center">
          <span
            class="text-medium has-ellipsis"
          >
            <slot>{{ label }}</slot>
          </span>
          <!-- TOOLTIP MODE -->
          <cly-tooltip-icon
            v-if="tooltip.length > 0 && !exposeMouseEvents"
            class="bu-is-flex-grow-1 bu-ml-1 text-cool-gray-40"
            :tooltip="tooltip"
          />
          <!-- CUSTOM POPUP MODE, SHOW ONLY INFO ICON, NOT TRIGGER TOOLTIP -->
          <i
            v-else-if="tooltip.length > 0 && exposeMouseEvents"
            class="ion ion-help-circled bu-ml-1 text-cool-gray-40 cursor-pointer"
            @mouseover="$emit('ontooltip')"
            @mouseleave="$emit('offtooltip')"
          />
        </div>
        <div
          :class="numberClasses"
          class="flex"
        >
          <div class="font-medium text-2xl">
            <slot
              v-if="number"
              name="number"
            >
              {{ formattedNumber }}
            </slot>
            <slot
              v-if="value"
              name="value"
            >
              {{ value }}
            </slot>
          </div>
        </div>
        <div class="bu-is-flex-grow-1">
          <slot name="description">
            <span class="text-xs text-cool-gray-50">{{ description }}</span>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
